import fire from "../../../services/fire";
import { getValidTimeRange } from "../../../utils/event";

export function getErrorCodeMapping(code) {
  const SUCCESS = 0;
  const MAX_KID_LIMIT = 1;
  const EVENT_FULL = 2;
  const EVENT_CLOSED = 3;
  // const EXCEEDED_LIMIT = 4;
  const DUPLICATE_BOOKING = 5;
  const PERMISSION_REQUIRED = 6;
  // const USER_NOT_FOUND = 7;
  const EVENT_NOT_FOUND = 8;
  const UNKNOWN_ERROR = 9;
  const BOOKING_DISABLED = 10;
  const UPDATE_REQUIRED = 11;
  // const INCORRECT_INPUT = 12;
  const INVALID_USER = 13;
  switch (code) {
    case SUCCESS:
      return "Booking Successful!";
    case MAX_KID_LIMIT:
      return "Maximum Kid Limit";
    case EVENT_FULL:
      return "Event is Already Full";
    case EVENT_CLOSED:
      return "Event is Already Closed";
    case DUPLICATE_BOOKING:
      return "Duplicate Booking";
    case PERMISSION_REQUIRED:
      return "Permission Required";
    case EVENT_NOT_FOUND:
      return "Event Not Found!";
    case BOOKING_DISABLED:
      return "Booking is Disabled";
    case UPDATE_REQUIRED:
      return "Update Required";
    case INVALID_USER:
      return "Invalid User";
    case UNKNOWN_ERROR:
    default:
      return "Ooops!";
  }
}

export async function callEventHubBooking(
  user,
  event,
  limits,
  settings,
  version
) {
  const userObj = {
    parish: user.parish,
    userid: user.userid,
    dob: user.dob,
    mobile: user.mobile,
    email: user.email,
    fullname: user.fullname,
    subid: user.subid,
    identification: user.identification,
  };
  // console.log({ event });
  const eventHubBooking = fire
    .functions("asia-east2")
    .httpsCallable("eventHubBooking");
  console.log("Calling eventHubBooking");

  const bookstatus = await eventHubBooking({
    user: userObj,
    event: {
      ...event,
      date: event.startDate,
    },
    limits: limits,
    settings: settings,
    webversion: version,
  });
  return bookstatus.data;
  //   return { message: `Booking for ${event.eventName} successful!`, status: 0 };
}

export async function getCurrentActiveEvent(eventArg) {
  const list = [];
  const { checkinopen, checkinclose, timestamp, orgId } = eventArg;
  const [start, end] = getValidTimeRange(checkinopen, checkinclose, timestamp);
  //cloud function or DB call
  const db = fire.firestore();
  const collection = `evententries`;
  const schedule = await db
    .collection(collection)
    .where("startDate", ">=", new Date(start))
    .where("startDate", "<=", new Date(end))
    .where("orgId", "==", orgId.toString())
    .get();

  schedule.forEach((doc) => {
    list.push(doc.data());
  });

  return list;
}

export async function getSelectedEventById(id) {
  const eventtimings = [];
  const db = fire.firestore();
  const snapshot = await db
    .collection(`evententries`)
    .where("eventId", "==", id)
    .orderBy("startDate", "asc")
    .get();

  snapshot.forEach(function (doc) {
    eventtimings.push(doc.data());
  });

  return eventtimings;
}
